
export default function HowItWorksSection() {
  const steps = [
    {
      step: 1,
      title: "Tell Us About Your Project",
      description: "Share your bathroom renovation needs, budget, and timeline through our simple form.",
      icon: "ri-edit-line",
      color: "bg-blue-100 text-blue-600"
    },
    {
      step: 2,
      title: "We Find Verified Contractors",
      description: "Our team matches you with pre-screened contractors who meet our strict verification standards.",
      icon: "ri-search-line",
      color: "bg-green-100 text-green-600"
    },
    {
      step: 3,
      title: "Get Connected & Compare",
      description: "Receive quotes from qualified contractors, review their portfolios, and choose the best fit.",
      icon: "ri-group-line",
      color: "bg-purple-100 text-purple-600"
    },
    {
      step: 4,
      title: "Start Your Dream Bathroom",
      description: "Work directly with your chosen contractor to bring your bathroom vision to life.",
      icon: "ri-home-smile-line",
      color: "bg-orange-100 text-orange-600"
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Getting connected with the perfect bathroom contractor has never been easier. 
            Here's our simple 4-step process.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center group">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-blue-200 transition-colors">
              <i className="ri-user-add-line text-3xl text-blue-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">1. Tell Us Your Needs</h3>
            <p className="text-gray-600 leading-relaxed">
              Share your bathroom project details, timeline, and budget. We'll match you with contractors who specialize in your type of project.
            </p>
          </div>

          <div className="text-center group">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-green-200 transition-colors">
              <i className="ri-search-eye-line text-3xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">2. We Find & Verify</h3>
            <p className="text-gray-600 leading-relaxed">
              Our team screens contractors using our 6-point verification process. Only the best, most reliable professionals make it to our network.
            </p>
          </div>

          <div className="text-center group">
            <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-purple-200 transition-colors">
              <i className="ri-palette-line text-3xl text-purple-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">3. Get Quotes & Designs</h3>
            <p className="text-gray-600 leading-relaxed">
              Receive detailed quotes with custom design concepts from 1-2 pre-screened contractors. Each includes layouts, material options, and visual ideas for your space.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
